const STIFFNESS = 380
const DAMPING = 30
const SAMPLE_EVERY_MS = 16
const MAX_DURATION_MS = 2000
const STEPS_TO_SETTLE = 30

const FALLBACK_SPRING: Spring = {
    easing: "cubic-bezier(0.34, 1.3, 0.64, 1)",
    durationMs: 420,
}

export const EASE_OUT_EXPO = "cubic-bezier(0.16, 1, 0.3, 1)"

interface Spring {
    easing: string
    durationMs: number
}

export const ISLAND_FADE: Spring = { easing: EASE_OUT_EXPO, durationMs: 320 }

export function sampleSpring(): Spring {
    const points = [0]
    let position = 0
    let velocity = 0
    let elapsedMs = 0
    let settledSteps = 0
    while (settledSteps < STEPS_TO_SETTLE && elapsedMs < MAX_DURATION_MS) {
        const acceleration = -STIFFNESS * (position - 1) - DAMPING * velocity
        velocity += acceleration / 1000
        position += velocity / 1000
        elapsedMs += 1
        if (elapsedMs % SAMPLE_EVERY_MS === 0) {
            points.push(Number(position.toFixed(4)))
        }
        const isAtRest =
            Math.abs(position - 1) < 0.002 && Math.abs(velocity) < 0.02
        settledSteps = isAtRest ? settledSteps + 1 : 0
    }
    points.push(1)
    return { easing: `linear(${points.join(", ")})`, durationMs: elapsedMs }
}

let spring: Spring | null = null

export function islandSpring(): Spring {
    if (!spring) {
        const isLinearSupported =
            typeof CSS !== "undefined" &&
            CSS.supports("transition-timing-function", "linear(0, 1)")
        spring = isLinearSupported ? sampleSpring() : FALLBACK_SPRING
    }
    return spring
}

export function islandMotionCssVariables(): Record<string, string> {
    const { easing, durationMs } = islandSpring()
    return {
        "--island-spring": easing,
        "--island-spring-ms": `${durationMs}ms`,
        "--island-fade": ISLAND_FADE.easing,
        "--island-fade-ms": `${ISLAND_FADE.durationMs}ms`,
    }
}

function wholeNumberIn(text: string | null): number | null {
    if (!text || !/^[\d.,\s\u00a0\u202f]+$/.test(text)) return null
    const digits = text.replace(/\D/g, "")
    return digits ? Number(digits) : null
}

export function countRollDirection({
    before,
    after,
}: {
    before: string | null
    after: string | null
}): number {
    const from = wholeNumberIn(before)
    const to = wholeNumberIn(after)
    if (from === null || to === null) return 0
    return Math.sign(to - from)
}
